

export default {
  name: 'ProductTablePrice',

  props: {
    title: {
      type: String,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },

    urlKey: {
      type: String,
      default: '',
    },

    name: {
      type: String,
      default: '',
    },

    enableLink: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      header: [
        {
          name: this.$t('City'),
          key: 'name',
          columnBemModifiers: ['header--hide'],
        },
        {
          name: this.$t('Price'),
          key: 'price',
          columnBemModifiers: ['header--hide'],
        },
      ],
    }
  },

  computed: {
    getPriceInCity () {
      return this.items.map((item) => {
        return {
          city: item.cityName,
          price: `${this.$t('from')} ${this.formatPrice(item.price)}`,
          slug: item.slug,
          virtual: item.isVirtual,
        }
      })
    },
  },

  methods: {
    formatPrice (price) {
      const currency = ['USD', 'PLN', 'RON', 'EUR'].includes(price?.currency) ? price?.currency : 'PLN'

      return new Intl
        .NumberFormat(this.$i18n.locale, { style: 'currency', currency })
        .format(price?.value)
    },

    getLink (isVirtual, slug) {
      return isVirtual ? { name: 'p-slug-virtual', params: { slug: this.urlKey, virtual: slug } } : { name: 'p-slug', params: { slug: this.urlKey }, query: { city: slug } }
    },
  },
}
